import React from 'react';
import { Link } from 'react-router-dom';

export class Contenu extends React.Component {
	render() {
		const data = this.props.data;
		const sens = data => {
			if (data.textPosition === 'droite') {
				return 'left';
			}
			if (data.textPosition === 'gauche') {
				return 'right';
			}
		};

		return (
			<div
				className="bg-white"
				style={
					data.textPosition == 'droite'
						? {}
						: { margin: '10px -60px 30px -20px' }
				}
			>
				{/* contenu */}
				<div
					style={{
						background: 'white',
						padding: '25px 70px 10px 70px',

						textAlign: 'justify'
					}}
				>
					{/* barre jaune */}
					<div
						style={
							data.textPosition == 'droite'
								? {
										marginLeft: '70%',
										marginTop: '37px',
										backgroundColor: '#f2c718',
										width: '100px',
										height: '3px',
										position: 'absolute',
										zIndex: '5'
								  }
								: {
										marginLeft: '-115px',
										backgroundColor: '#f2c718',
										width: '120px',
										height: '3px',
										marginTop: '60px'
								  }
						}
					></div>
					{/* ************************ */}

					<h3
						className="ft-lato-light text-center pt-4"
						style={{ color: '#333' }}
					>
						{data.titre}
					</h3>
					<h3
						className="ft-parisienne pt-2 text-center"
						style={{ color: '#333' }}
					>
						{data.sousTitre}
					</h3>
					<p
						className="pt-3 mb-5"
						style={{
							textAlign: data.textPosition == 'droite' ? 'left' : 'right'
						}}
					>
						{data.contenu}
					</p>
				</div>

				{data.boutons.map(element => {
					return (
						<div className="text-center" style={{ paddingBottom: '70px' }}>
							<Link
								to={element.lien}
								className="text-center mt-5 ft-lato-light p-3 text-uppercase"
								style={{
									fontSize: '1.1em',
									color: '#333',
									border: '1px solid #000'
								}}
							>
								{element.nom}
							</Link>
						</div>
					);
				})}

				<div style={{}}></div>
				{/* ************* */}
			</div>
		);
	}
}
